import React from "react";
import avatar from "../../../icons/avatar.png";

const FullfilmentProfile = () => {
  return (
    <div>
      <h1 className="font-bold text-2xl uppercase text-gray-500 pb-10">
        My Profile and setting
      </h1>
      <div className="mt-10 ">
        <h1 className="font-bold text-md text-gray-500 pb-10">Avatar</h1>
        <div className="md:flex justify-start items-center gap-10">
          <div className="avatar mr-4">
            <div className="md:w-36 w-32 rounded-full ring ring-green-400 ring-offset-base-100 ring-offset-1">
              <img src={avatar} alt="" />
            </div>
          </div>
          <div>
            <p className="mb-10 w-full md:w-3/5 text-gray-500">
              Your avatar is one of the defining parts of your profile. It'll
              help designers or clients establish an impression of you.
            </p>
            <label
              className="bg-primary text-white rounded-xl px-7 py-3 "
              htmlFor="avatar"
            >
              <span>Upload Photo</span>
              <input className="hidden" type="file" name="" id="avatar" />
            </label>
          </div>
        </div>
        <div className="my-20 w-full md:w-3/5">
          <h1 className="font-bold text-lg text-gray-500 mb-10">
            Personal Information
          </h1>
          <form>
            <div className="w-full grid grid-cols-3 gap-3">
              <label className="text-gray-500 font-bold" htmlFor="">
                Company Name:
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="text"
                placeholder=""
                name=""
                id=""
              />
              <label className="text-gray-500 font-bold" htmlFor="">
                Name and Lastname:
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="text"
                placeholder=""
                name=""
                id=""
              />
              <label className="text-gray-500 font-bold" htmlFor="">
                Email:
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="email"
                placeholder=""
                name=""
                id=""
              />
              <label className="text-gray-500 font-bold" htmlFor="">
                Phone
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="text"
                placeholder=""
                name=""
                id=""
              />
            </div>
            <input
              className="bg-gray-400 text-white rounded-xl px-9 py-3 mt-10"
              type="submit"
              value={"Edit"}
            />
          </form>
        </div>

        <div className="my-20 w-full md:w-3/5">
          <h1 className="font-bold text-lg text-gray-500 mb-10">
            Change My Password
          </h1>
          <form>
            <div className="w-full grid grid-cols-3 gap-3">
              <label className="text-gray-500 font-bold" htmlFor="">
                Current Password:
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="password"
                name=""
                id=""
              />
              <label className="text-gray-500 font-bold" htmlFor="">
                New Password:
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="password"
                name=""
                id=""
              />
              <label className="text-gray-500 font-bold" htmlFor="">
                Confirm Password:
              </label>
              <input
                className="text-gray-500 p-2 w-full col-span-2"
                type="password"
                name=""
                id=""
              />
            </div>
            <div className="flex justify-end mt-5">
              <button className="text-gray-500 ">Forgot password</button>
            </div>
            <input
              className="bg-gray-300 text-white rounded-xl px-9 py-3 mt-10"
              type="submit"
              value={"Save"}
            />
            <input
              className="bg-gray-400 text-white rounded-xl px-9 py-3 mt-10 ml-5"
              type="submit"
              value={"Cancel"}
            />
          </form>
        </div>
      </div>
    </div>
  );
};

export default FullfilmentProfile;
